import { useEffect, useState } from 'react';
import Select from 'react-select';
import styles from './NewStock.module.css';
import axiosInstance from '../../../Configuration/axiosInstance';

const NewStock = () => {
  const [products, setProducts] = useState();
  const [prodID, setProdID] = useState();
  const [warehouses, setWareHouses] = useState();
  const [warehouseArr, setWarehouseArr] = useState([]);
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');

  useEffect(() => {
    axiosInstance.get(`products/allproducts`).then((data) => {
      setProducts(data.data.data);
    });
    axiosInstance.get(`warehouse`).then((res) => {
      console.log(res.data.data);
      setWareHouses(res.data.data);

      setWarehouseArr(
        res.data.data.map((warehouse) => ({
          warehouse: warehouse._id,
          quantity: 0,
        }))
      );
    });
  }, []);
  const productHandler = (options) => {
    const { value } = options;
    setProdID({ label: value });
    setError('');
    setMsg('');
  };

  const handleQuantityChange = (warehouseID, quantity) => {
    setWarehouseArr((prev) =>
      prev.map((item) =>
        item.warehouse === warehouseID ? { ...item, quantity } : item
      )
    );
  };

  const productOptions = products?.map((i) => ({
    value: i._id,
    label: `${i.productName}-${i.sku}`,
  }));

  const addStock = async () => {
    // Get all warehouse IDs
    const allWarehouseIDs = warehouses.map((warehouse) => warehouse._id);

    // Create a mapping of warehouse IDs to quantities from the warehouseArr
    const quantityMapping = {};
    warehouseArr.forEach((warehouse) => {
      quantityMapping[warehouse.warehouse] = warehouse.quantity;
    });

    // Initialize quantities for unselected warehouses as 0
    const updatedWarehouseArr = allWarehouseIDs.map((warehouseID) => ({
      warehouse: warehouseID,
      quantity: quantityMapping[warehouseID] || 0,
    }));

    setWarehouseArr(updatedWarehouseArr);
    console.log(updatedWarehouseArr);

    try {
      const res = await axiosInstance.post(`stockRoute`, {
        product: prodID.label,
        warehouses: updatedWarehouseArr,
      });
      setMsg(res.data.message);
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status <= 500
      ) {
        setError(error.response.data.message);
      }
    }
  };

  return (
    <>
      <h2>Add New Stock</h2>
      <div className={styles.container}>
        <label>Select a Product: </label>
        <Select
          name='product'
          options={productOptions}
          onChange={productHandler}
        />
        <hr />
        <label>Quantity in each warehouse: </label>
        <div className={styles.warehouseContainer}>
          <table>
            <thead className={styles.headers}>
              <th>Warehouse Name</th>
              <th>Quantity</th>
            </thead>
            <tbody>
              {warehouses?.map((warehouse, index) => {
                const warehouseData = warehouseArr.find(
                  (item) => item.warehouse === warehouse._id
                );

                return (
                  <tr key={index} className={styles.warehouses}>
                    <td>{warehouse.name}</td>
                    <td>
                      <input
                        type='number'
                        value={warehouseData?.quantity}
                        onChange={(e) =>
                          handleQuantityChange(warehouse._id, e.target.value)
                        }
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div>
          <button className='confirmBtn' onClick={addStock}>
            Add Stock
          </button>
        </div>
        {error && <div>!{error}</div>}
        {msg && <div>!{msg}</div>}
      </div>
    </>
  );
};

export default NewStock;
